/* Spanish catalog mirroring locale-advisor-plan-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'adv.plan.viewForecast': 'Ver previsión',
  'adv.plan.forecastTitle': 'Flujo de caja con eventos planificados',
  'adv.plan.forecastIntro': 'Compara el saldo según las cifras contabilizadas con el saldo tras los eventos que has introducido.',
  'adv.plan.forecastWithoutEvents': 'Sin eventos planificados',
  'adv.plan.forecastWithEvents': 'Con eventos planificados',
  'adv.plan.forecastChange': 'Variación a fin de año',
  'adv.plan.forecastScope': 'Los eventos planificados solo modifican la previsión, no la contabilidad ni el presupuesto. La curva se detiene en cero, por lo que la variación a fin de año puede ser menor que la suma de los eventos.',
  'adv.plan.showVariance': 'Mostrar desviaciones',
  'adv.plan.hideVariance': 'Ocultar desviaciones',
});
